// extracted by mini-css-extract-plugin
export default {"root":"m6i2i__root","button":"P1Jzi__button","label":"VOJCD__label","disabled":"GE1Gj__disabled","icon":"i1qRz__icon","mixed":"KzwNh__mixed"};